




















































import { defineComponent, ref } from '@vue/composition-api'
import SvgEye from '../icons/SvgEye.vue'
import KaiButton from '../common/KaiButton.vue'
import SelectedTagCategory from '../tags/SelectedTagCategory.vue'
import { useActions } from '../../store/useActions'
import { useGetters } from '../../store/useGetters'
import SelectedTag from '../../components/tags/SelectedTag.vue'

export default defineComponent({
  name: 'SelectedTagsList',
  components: { SelectedTag, SvgEye, KaiButton, SelectedTagCategory },
  setup() {
    const isShowAll = ref(false)

    const actions = useActions({
      toggleAllTags: 'transcriptTags/toggleAllTags',
      toggleTag: 'transcriptTags/toggleTag',
      toggleCategory: 'transcriptTags/toggleCategory',
      toggleCategoryVisibility: 'transcriptTags/toggleCategoryVisibility'
    })

    const getters = useGetters({
      tagCategories: 'transcriptTags/categories'
    })

    const toggleTag = (tagId: number) => {
      actions.toggleTag(tagId)
    }

    const toggleCategory = (id: number, status: boolean) => {
      actions.toggleCategory({ id, status })
    }

    const toggleTagsButton = () => {
      isShowAll.value = !isShowAll.value
      actions.toggleAllTags(!isShowAll.value)
    }

    const toggleCategoryVisibility = (id: number) => {
      actions.toggleCategoryVisibility(id)
    }

    return {
      toggleTagsButton,
      toggleCategory,
      toggleTag,
      toggleCategoryVisibility,
      tagCategories: getters.tagCategories,
      isShowAll
    }
  }
})
